import SelectionUpdater from "./SelectionUpdater";
import messageResource from "../messageResource"

export default class UnlockingSelectionUpdater extends SelectionUpdater {
    constructor(lockTable, selection, selectionVeil) {
        super(lockTable, selection, messageResource.getMessage("lock_tt.table.veil.unlocking"), selectionVeil);
    }

    handleResult(result) {
        this.selection.visitUserCells(function(cell) {
            if (cell.getValue().locked) {
                cell.getValue().locked = false;
                cell.getValue().lockDate = null;
                cell.getValue().whoLocked = null;
            }
        });

        this.runnerController.regionUnlocked(this.lockTable, this.selection);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/UnlockingSelectionUpdater.js